/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseReference } from './courseReference';

/**
 * DEPRECATED: Do not use for navigation. List of courses this module belongs to.
 */
export type CourseModuleCourses = CourseReference[] | null;
